import type {SystemStyleObject} from '@chakra-ui/system';
import {createStylesContext} from '@chakra-ui/system';

import type {Part} from './anatomy';

export const [StylesProvider, _useStyles] = createStylesContext(`BarChart`);

export const useStyles = _useStyles as () => Record<Part, SystemStyleObject>;
